module.exports = __webpack_public_path__ + "media/backgrounds/martin-bennie-WNUzH97lDc0-unsplash-a04a1e25.jpg";